module.exports = __webpack_public_path__ + "img/logo.c0bf69b0.svg";